<script>
  import { urlServeur } from "./conf.js";

  let src = "";
  let resultMail = null;

  if (urlServeur.indexOf("makutu", 1) != -1) {
    src = "https://www.capitainemaree.com/mar%C3%A9e/Colleville-Montgomery/";
  }

  // src="https://www.capitainemaree.com/mar%C3%A9e/Colleville-Montgomery/"
  const getSrc = () => {
    src = "https://www.capitainemaree.com/mar%C3%A9e/Colleville-Montgomery/";
  };

  const sendmail = async () => {
    const response = await fetch(
      "https://makutu.site/ci_cicd_intra/index.php/api_domaine/mailartisan"
    );

    if (response.ok) {
      const result = await response.json();
      console.log(result);
      resultMail = result.PAYLOAD;
    }
  };
</script>

<div class="container">
  <div>
    <button class="btn btn-info" on:click|preventDefault={sendmail} disabled
      >Send mail</button
    >
    <pre>
    {#await resultMail then}
        {resultMail}
      {/await}
    </pre>
  </div>
  {#if src == ""}
    <div>
      <iframe
        title="cotation or"
        src="https://or.fr/widget/live-price/XAU?currency=EUR"
        width="100%"
        height="130"
        style="border: 0; overflow: hidden;"
      />
    </div>

    <div>
      <button class="btn btn-info" on:click|preventDefault={getSrc}
        >voir les horaires</button
      >
    </div>
  {/if}

  <iframe {src} title="dd" width="100%" height="600px" frameborder="0" />
</div>
